import cx from 'classnames';
import 'react';

import GenericInputWrapper from './generic-wrapper/generic-input-wrapper';

const GenericSelectInput = (
  {
    ref,
    ...props
  }
) => {
  return <GenericInputWrapper {...props} as="select" ref={ref} />;
};

GenericSelectInput.displayName = 'GenericSelectInput';

export default GenericSelectInput;
